

























import { Component, Vue } from 'vue-property-decorator';
import Login from '@/components/Login.vue';
import store from '@/store';

@Component({
  components: {
    Login,
  },
})
export default class LoginView extends Vue {
  get loggedIn() {
    return store.getters['auth/authenticated'];
  }

  public created() {
    if (this.loggedIn) {
      this.$router.push('/selectGame?mode=play');
    }
  }

  public onLoggedIn() {
    this.$router.push('/selectGame?mode=play');
  }

  public onShowSignUp() {
    this.$router.push('/signup');
  }
}
